import { v4 as uuidv4 } from "uuid";
import { Badge } from "@/components/ui/badge";
import { useProductDetailsState } from "../../../hooks/useProductDetailsState";
import { useTranslate } from "../../../hooks/useTranslate/useTranslate";

//------------------------------------------------------------------------------------
/* Barcodes */
//export type BarcodesFieldProps = {};
export const BarcodesField: React.FC /*<BarcodesFieldProps>*/ = () => {
	const productDetailsState = useProductDetailsState();
	const translate = useTranslate();

	if (productDetailsState.get().product?.Barcodes) {
		return (
			<div className="field">
				<div className="caption">{translate("Barcodes")}:</div>
				<div className="value">
					{productDetailsState
						.get()
						.product?.Barcodes?.split(",")
						.map((tag) => (
							<span
								key={(productDetailsState.get().product?.Id || uuidv4()) + tag}
							>
								{tag && (
									<Badge variant="outline" className="mx-1 my-1">
										{tag}
									</Badge>
								)}
							</span>
						))}
				</div>
			</div>
		);
	} else {
		return null;
	}
};
